import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import JumboCardQuick from 'app/components/JumboCardQuick';
import { ColorsV2 } from 'app/constants/color';
import ActivitiesList from './QuickGuideList';

const QuickGuide = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'recent_activities' });

  return (
    <JumboCardQuick wrapperSx={{ p: 0 }}>
      <Typography
        sx={{
          backgroundColor: ColorsV2.primary,
          color: ColorsV2.white,
          fontSize: '0.8em',
          fontWeight: 500,
          paddingX: '20px',
          paddingY: '15px',
          margin: '0 0 15px',
          height: '5%',
          borderBottom: `1px solid ${ColorsV2.outline}`,
        }}
      >
        {t('Welcome to the NIC Portal - Quick Guide')}
      </Typography>
      <Box sx={{ overflowY: 'scroll', height: '58vh' }}>
        <ActivitiesList />
      </Box>
    </JumboCardQuick>
  );
};
export default QuickGuide;
